module.exports = __webpack_public_path__ + "static/media/promo-b-3.374bb2d8.png";